export default __webpack_public_path__ + "static/media/sqrt.c8b770c0.svg";